/**
 * A public site photo, converted from the print files: `${src}.webp` at full
 * size and `${src}-800.webp` for phones, so the browser picks the smaller one
 * where it is enough.
 */
export default function SiteImage({
  src,
  width,
  height,
  alt,
  sizes,
  className = '',
  priority = false,
}: {
  src: string;
  width: number;
  height: number;
  alt: string;
  sizes: string;
  className?: string;
  priority?: boolean;
}) {
  return (
    <img
      src={`${src}.webp`}
      srcSet={`${src}-800.webp 800w, ${src}.webp ${width}w`}
      sizes={sizes}
      width={width}
      height={height}
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      decoding="async"
      className={className}
    />
  );
}
